class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure_element'),
    };
    if (!this.elements.input || !this.elements.button || !this.elements.panel) return;

    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  setCurrencySelection(country, label, flag) {
    const currencyLabel = this.querySelector('[data-active-currency]');
    const flagElement = this.querySelector('[data-active-flag]');
    if (!currencyLabel || !flagElement || !country || !label || !flag) return;

    currencyLabel.textContent = label;
    flagElement.className = `ivs-currency-flag ivs-flag--${flag}`;
    this.querySelectorAll('[data-country]').forEach(item => {
      const isActive = item.dataset.country === country;
      item.classList.toggle('link-active', isActive);
      if (isActive) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  }

  restoreCurrencySelection() {
    if (!this.querySelector('[data-currency]')) return;
    const selectedOption =
      this.querySelector('[data-currency][aria-current="true"]') ||
      this.querySelector('[data-currency]');
    const country = selectedOption?.dataset.country;
    const label = selectedOption?.dataset.label;
    const flag = selectedOption?.dataset.flag;
    if (country && label && flag) this.setCurrencySelection(country, label, flag);
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const currency = target.dataset.currency;
    const label = target.dataset.label;
    const flag = target.dataset.flag;
    const value = target.dataset.value;
    const form = this.querySelector('form');

    if (currency && label && flag) {
      this.setCurrencySelection(value, label, flag);
      this.elements.input.value = value || this.elements.input.value;
      document.querySelectorAll('localization-form').forEach(form => form.restoreCurrencySelection?.());
      if (form && value) {
        this.updateReturnUrl(value);
        form.submit();
        return;
      }
      this.hidePanel();
      return;
    }

    this.elements.input.value = value;
    if (form) {
      this.updateReturnUrl(value);
      form.submit();
    }
  }

  updateReturnUrl(countryCode) {
    const returnToInput = this.querySelector('input[name="return_to"]');
    if (!returnToInput || !countryCode) return;

    returnToInput.value = `${window.location.pathname}${window.location.search}`;
  }

  openSelector() {
    this.elements.button.focus();
    const isOpening = this.elements.panel.hasAttribute('hidden');
    document.querySelectorAll('localization-form .disclosure_element:not([hidden])').forEach(panel => {
      if (panel !== this.elements.panel) {
        panel.setAttribute('hidden', true);
        panel.closest('localization-form')?.querySelector('button')?.setAttribute('aria-expanded', 'false');
      }
    });
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', isOpening.toString());
  }

  closeSelector(event) {
    if (event.target.classList.contains('country-selector__overlay') || !this.contains(event.target) || !this.contains(event.relatedTarget)) {
      this.hidePanel();
    }
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('localization-form').forEach(form => form.restoreCurrencySelection?.());
});
